import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEn from "../../locales/en.json";
import translationFr from "../../locales/fr.json";

// Define your translations here or import them from other files
const resources = {
  en: { translation: translationEn },
  fr: { translation: translationFr }
  // Add more languages if needed
};

i18n.use(initReactI18next).init({
  resources,
  lng: "fr", // Default language
  fallbackLng: "fr", // Fallback language if the selected one is unavailable
  interpolation: {
    escapeValue: false, // React already escapes strings
  },
});

export default i18n;
